import { useQuery } from "@tanstack/react-query";

const useDashboardTotal = () => {
  const userId = localStorage.getItem("uI");
  const user_id = userId - 786;
  const {
    refetch,
    isLoading,
    isError,
    error,
    isSuccess,
    data: dashboardTotalInfo = [],
  } = useQuery({
    queryKey: ["dashboardTotalInfo"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/dashboardStatistics/${user_id}`
      );
      const data = await res.json();
      return data;
    },
  });
  return [dashboardTotalInfo, isLoading, isError, error, isSuccess, refetch];
};

export default useDashboardTotal;
